<template>
  <table class="table table-details">
    <tr>
      <td><label>{{ $t('generic.id') }}</label></td>
      <td>{{ details.id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('emails.account_id') }}</label></td>
      <td>{{ details.account_id }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.created') }}</label></td>
      <td>{{ details.created_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.updated') }}</label></td>
      <td>{{ details.updated_at | time }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('emails.from') }}</label></td>
      <td>{{ details.from }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('emails.language') }}</label></td>
      <td>{{ details.language }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('emails.retries') }}</label></td>
      <td>{{ details.retries }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('generic.status') }}</label></td>
      <td>{{ details.status }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('emails.status_message') }}</label></td>
      <td>{{ details.status_message }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('emails.template_type') }}</label></td>
      <td>{{ details.template_type }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('emails.subject') }}</label></td>
      <td>{{ details.subject }}</td>
    </tr>
    <tr>
      <td><label>{{ $t('emails.body_type') }}</label></td>
      <td>{{ details.body_type }}</td>
    </tr>
  </table>
</template>
<script>
  export default {
    name: 'email-details',
    components: {},
    props: {
      details: {
        type: Object,
        required: true,
      },
    },
    computed: {}
  };
</script>
<style></style>
